import { render, staticRenderFns } from "./UOBProposalDownload.vue?vue&type=template&id=8e1f945a&"
import script from "./UOBProposalDownload.vue?vue&type=script&lang=js&"
export * from "./UOBProposalDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports